module.exports = __webpack_public_path__ + "62ca5930d819dc115ba47db91a7abf9e.jpg";